<template>
  <div class="bg-gray-50 rounded px-3 py-2 text-xs font-semibold">
    <template v-if="value">
      <span>{{ value }}</span>
    </template>
    <slot v-else />
  </div>
</template>

<script src="./tag.component.ts" lang="ts" />
